import _reduce from 'lodash/reduce'
import _forEach from 'lodash/forEach'
import _fpOmit from 'lodash/fp/omit'
import _fpValues from 'lodash/fp/values'
import _fpKeys from 'lodash/fp/keys'
import _fpMap from 'lodash/fp/map'
import _fpSlice from 'lodash/fp/slice'

// 排除分类的id
const excludeCid = ['0']
// 每个分类截取数量
const sliceEnd = 6

function arr2chunk (arr) {
  let arr1 = []
  let arr2 = []
  let arr3 = []
  _forEach(arr, (val, idx) => {
    switch (true) {
      case idx % 3 === 0:
        arr1.push(val)
        break
      case idx % 3 === 1:
        arr2.push(val)
        break
      case idx % 3 === 2:
        arr3.push(val)
        break
    }
  })
  return [arr1, arr2, arr3]
}

let chunkFromValue = data => _reduce(
  [_fpOmit(excludeCid), _fpValues, _fpMap(_fpSlice(0, sliceEnd)), arr2chunk],
  (acc, fn) => fn(acc),
  data
)
let chunkFromKey = data => _reduce(
  [_fpOmit(excludeCid), _fpKeys, arr2chunk],
  (acc, fn) => fn(acc),
  data
)

export default {
  chunkFromKey,
  chunkFromValue
}



// WEBPACK FOOTER //
// ./src/assets/utils/arr2chunk.js